import React from 'react';
import s from './GenericInfo.module.scss';
import { Divider } from 'ui-v2/components/Divider';
import { Typography } from 'ui-v2/components/Typography';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { GenericInfoType } from 'src/modules/parkplusStoreV2/types/product';

type GenericInfoPropType = {
  data: GenericInfoType[];
};
export const GenericInfo = ({ data }: GenericInfoPropType) => {
  return (
    <>
      <div className={s.root}>
        <div className={s.list}>
          {data?.map((item, ind) => (
            <>
              <div key={ind} className={s.item}>
                <ShimmerImage src={item?.icon} className={s.icon} />
                <Typography
                  label={item?.text}
                  variant="body_3_medium"
                  color="secondary"
                />
              </div>
              {ind === 0 && <div className={s.line} />}
            </>
          ))}
        </div>
      </div>
      <Divider variant="padded" />
    </>
  );
};
